import { cn } from "@/lib/cn";
import type { Scale } from "./tokens";

const SIZE_CLASS = {
  xs: "size-3.5 border-2",
  sm: "size-4 border-2",
  md: "size-5 border-2",
  lg: "size-7 border-[3px]",
  xl: "size-9 border-[3px]",
} satisfies Record<Scale, string>;

export interface LoaderProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: Scale;
  /** Color del trazo giratorio · default hereda `currentColor` (para verse bien dentro de un botón). */
  color?: "current" | "multiva";
}

/** Reemplazo de `<Loader>` de Mantine · spinner circular vía `border` + `animate-spin`. */
export function Loader({ size = "sm", color = "current", className, ...props }: LoaderProps) {
  return (
    <span
      role="status"
      aria-label="Cargando"
      className={cn(
        "inline-block shrink-0 animate-spin rounded-full border-solid",
        SIZE_CLASS[size],
        color === "current"
          ? "border-current border-t-transparent"
          : "border-multiva-200 border-t-multiva-600",
        className
      )}
      {...props}
    />
  );
}
